<div class="w-100 h-100">
    <div class="d-flex justify-content-center">
        <div class="box pb-3">
            <div class="card-box bg-blue" :class="{'active': requestStatusBox.includes('0') || requestStatusBox.length === 0 }" @click="filter('0', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.all')}}<br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.all}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-pink" :class="{'active': requestStatusBox.includes('1')&& !requestStatusBox.includes('0')}" @click="filter('1', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.pendingFor')}} <br /> {{$t('dashboardPage.approval')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.pendingForApproval}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.pendingForApprovalPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div v-if="userRole == 1 || userRole == 9 || userRole == 15" class="box pb-3">
            <div class="card-box bg-deep-purple" :class="{'active': requestStatusBox.includes('10')&& !requestStatusBox.includes('0')}" @click="filter('10', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.pendingFor')}} <br /> {{$t('dashboardPage.review')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.pendingForReview}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.pendingForReviewPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-green" :class="{'active': requestStatusBox.includes('2')&& !requestStatusBox.includes('0')}" @click="filter('2', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.approved')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.approved}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.approvedPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-red" :class="{'active': requestStatusBox.includes('3')&& !requestStatusBox.includes('0')}" @click="filter('3', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.rejected')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.rejected}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.rejectedPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-gray" :class="{'active': requestStatusBox.includes('4')&& !requestStatusBox.includes('0')}" @click="filter('4', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.paid')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.paid}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.paidPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-dark-blue" :class="{'active': requestStatusBox.includes('5')&& !requestStatusBox.includes('0')}" @click="filter('5', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.expired')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.expired}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">&nbsp;</div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-parpol" :class="{'active': requestStatusBox.includes('11') && !requestStatusBox.includes('0')}" @click="filter('11', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.deactivated')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.deactivated}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">&nbsp;</div>
            </div>
        </div>
    </div>
    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="reload()"></i>
                                {{$t('dashboardPage.requests')}} ({{sendersCount}})
                            </label>
                        </div>
                        <div class="col-auto">
                            <button v-if="userRole == 2 || userRole == 5 && isExportExcelForProviderEnabled" class="btn btn-primary btn-action" @click="exportToExcel()">{{$t('dashboardPage.exportToExcel')}}</button>
                            <button v-if="((userRole == 2 || userRole == 5) && !providerLocked && !providerExpired && !providerDissconected)" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showresendDialog('')">{{$t('dashboardPage.resend')}}</button>
                            <button v-if="userRole == 2 || userRole == 5" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="PreparePay('')">{{$t('dashboardPage.Pay')}}</button>
                            <button v-if="userRole == 2 || userRole == 5" class="btn btn-primary btn-action" @click="openCheckAvailabilityDialog()">{{$t('dashboardPage.checkAvailability')}}</button>
                            <button v-if="requestsOptions.isRenewRequstEnabled && (userRole == 2 || userRole == 5) && !providerDissconected" @click="checkRenewSender('')" class="btn btn-primary btn-action">{{$t('dashboardPage.renew')}}</button>
                            <router-link v-if="((userRole == 2 || userRole == 5) && !providerLocked  && !providerExpired && !providerDissconected)&& requestsOptions.isNewRequestEnabled" to="/Dashboard/AddRequest" tag="button" class="btn btn-primary btn-action">{{$t('dashboardPage.newRequest')}} <i class="fas fa-plus px-2"></i></router-link>
                            <button v-if="userRole == 1 || userRole == 9 || userRole == 15" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showapproveDialog('')">{{$t('dashboardPage.Approve')}}</button>
                            <button v-if="userRole == 1 || userRole == 9 || userRole == 15" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showRejectDialog()">{{$t('dashboardPage.reject')}}</button>
                            <button v-if="userRole == 1 || userRole == 9 || userRole == 3" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showDeactivateDialog('')">{{$t('dashboardPage.deactivate')}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-row align-items-start w-100">
                        <div class="col">
                            <div class="form-row flex-md-nowrap">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.displayId"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.displayId')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.senderName"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.senderNameSearch')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               @input="onInputSearch"
                                               v-model="filterModel.clientName"
                                               :placeholder="$t('dashboardPage.clientName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="(userRole != 2  && userRole != 5)" class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               @input="onInputSearch"
                                               v-model="filterModel.providerName"
                                               :placeholder="$t('dashboardPage.providerName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" v-if="userRole == 2 || userRole == 5">
                                    <div class="input-group mb-3">
                                        <v-select :items="requestsDateExpiryOptions"
                                                  v-model="requestsFilterExpiryOption"
                                                  item-text="name"
                                                  item-value="id"
                                                  :label="$t('shortPage.remaningDays')"
                                                  solo attach>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto mb-3" v-if="userRole == 9 || userRole == 1 || userRole == 3 || userRole == 4 || userRole == 15 || userRole == 2 || userRole == 5">
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <div class="form-row align-items-start w-100" v-if="userRole == 2 || userRole == 5">
                        <div class="col">
                            <div class="form-row flex-md-nowrap">
                                <div class="col mb-4">
                                    <div class="input-group mb-3">
                                        <v-menu v-model="createdDateFromMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                lazy
                                                full-width
                                                min-width="290px"
                                                offset-y attach>
                                            <template v-slot:activator="{ on }">
                                                <div class="input-group">
                                                    <input class="form-control border-right-0 border-left"
                                                           v-model="filterModel.createdDateFrom"
                                                           :placeholder="$t('shared.createdDateFrom')"
                                                           readonly
                                                           :clearable="true"
                                                           ref="createdDatePicker" v-on="on" type="text" />
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text right gray">
                                                            <i class="far fa-calendar-alt"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <v-date-picker v-model="filterModel.createdDateFrom"
                                                           no-title
                                                           scrollable
                                                           @input="onDateChange('from')">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                                <div class="col mb-4">
                                    <div class="input-group mb-3">
                                        <v-menu v-model="createdDateToMenu"
                                                :close-on-content-click="false"
                                                lazy
                                                full-width
                                                :nudge-right="40"
                                                min-width="290px"
                                                transition="scale-transition" offset-y attach>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div class="input-group">
                                                    <input class="form-control border-right-0 border-left"
                                                           v-model="filterModel.createdDateTo"
                                                           :placeholder="$t('shared.createdDateTo')"
                                                           readonly v-bind="attrs"
                                                           ref="createdDatePicker" v-on="on" type="text" />
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text right gray">
                                                            <i class="far fa-calendar-alt"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <v-date-picker v-model="filterModel.createdDateTo" no-title scrollable
                                                           @input="onDateChange('to')">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                                <div class="col mb-4"></div>
                                <div class="col mb-4"></div>
                            </div>
                        </div>
                        <div class="col-auto mb-3">
                            <button class="btn btn-primary btn-action invisible" tabindex="-1" aria-hidden="true">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <template>
                        <v-data-table v-model="selected"
                                      :headers="headers"
                                      :items="senders"
                                      :total-items="sendersCount"
                                      select-all
                                      :pagination.sync="pagination"
                                      @update:pagination="updatePaginate"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      item-key="requestId"
                                     :loading="isLoading"
                                      class="elevation-1 table-striped">
                            <template v-slot:headers="props">
                                <tr>
                                    <th>
                                        <v-checkbox :input-value="props.all"
                                                    :indeterminate="props.indeterminate"
                                                    primary 
                                                    hide-details
                                                    @click.stop="selectAll"></v-checkbox>
                                    </th>
                                    <th class="text-center" v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column sortable', pagination.descending ? 'desc' : 'asc', (header.value === pagination.sortBy) && isSorted ? 'active' : '']"
                                        @click="changeSort(header.value)" :width="header.width !== ''? header.width : ''">
                                        <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-checkbox v-model="props.selected"
                                                    @change="select($event, props.item.id)"
                                                    primary
                                                    hide-details></v-checkbox>
                                    </td>
                                    <td class="text-center">
                                        <v-tooltip bottom v-if="props.item.isScamSender">
                                            <template v-slot:activator="{ on }">
                                                <span v-on="on">
                                                    {{ props.item.displayId }}
                                                    <v-icon v-if="props.item.isScamSender &&(userRole == 1 || userRole == 3
                                                        || userRole == 4|| userRole == 9 || userRole == 15)" larg style="color:red">warning_amber</v-icon>
                                                </span>
                                            </template>
                                            <span>The sender name may be considered suspecious</span>
                                        </v-tooltip>
                                        <span v-if="!props.item.isScamSender">{{ props.item.displayId }}</span>
                                    </td>
                                    <td class="text-center">{{props.item.senderName}}</td>
                                    <td class="text-center">
                                        <v-icon v-if="props.item.isClientFavorite && (userRole == 2 || userRole == 5)"
                                                :style="{color: favoriteIconColor, fontSize: '20px' }">
                                            mdi-star-circle-outline
                                        </v-icon>
                                        {{ props.item.clientName }}
                                    </td>
                                    <td class="text-center" v-if="(userRole != 2  && userRole != 5)">{{ props.item.providerName }}</td>
                                    <td class="text-center">{{ props.item.createdDate }}</td>
                                    <td class="text-center">{{ props.item.expiryDate }}</td>
                                    <td class="text-center">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="status_txt" :class="'status-' + props.item.requestStatus" :style="{ color: checkColor(props.item.requestStatus) }">{{GetSenderStatus(props.item.requestStatus)}}</div>
                                            <Progress :transitionDuration="1000" :radius="10" :strokeColor="checkColor(props.item.requestStatus)" :strokeWidth="5" :value="getRate(props.item.remainingDays,props.item.totalDays)">
                                                <div class="content"></div>
                                                <template v-slot:footer>
                                                    <b></b>
                                                </template>
                                            </Progress>
                                            <div class="days_left">
                                                {{props.item.remainingDays}} {{$t('dashboardPage.of')}} {{props.item.totalDays}} <br /> {{$t('dashboardPage.daysLeft')}}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center btn_menu">
                                        <template>
                                            <v-menu offset-y open-on-hover>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn color="btn-primary"
                                                           v-on="on">
                                                        <div>{{$t('shared.actions')}}</div>
                                                        <i class="fas fa-chevron-down pl-4" style="vertical-align: sub;"></i>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-tile v-if="userRole == 9 && props.item.requestStatus == '10'" @click="showFinalapproveDialog(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.finalApprove')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="(userRole == 2 || userRole == 5 )&& props.item.requestStatus == '2'" @click="PreparePay(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.Pay')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="((userRole == 1 || userRole == 9 || userRole == 15) && props.item.requestStatus == '1' && ((userRole == 1 && props.item.tenantId == tenantId) || userRole != 1)) || ((userRole == 1 || userRole == 9 || userRole == 15) && props.item.requestStatus == '3')"
                                                                 @click="showapproveDialog(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.Approve')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="((userRole == 1  || userRole == 9) && ((userRole == 1 && props.item.tenantId == tenantId) || userRole != 1) && (props.item.requestStatus == '2' ||props.item.requestStatus == '4'||props.item.requestStatus == '5' ) && ( props.item.senderStatus != 4 && props.item.senderStatus != 6))
                                                                 ||((userRole == 2 || userRole == 5) && props.item.requestStatus == 3)"
                                                                 :to="'/Dashboard/EditSender/' + props.item.id ">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.edit')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="(userRole == 1  || userRole == 9|| userRole == 3) && ((userRole == 1 && props.item.tenantId == tenantId) || userRole != 1) && (props.item.requestStatus == '4' || props.item.requestStatus == '5') && ( props.item.senderStatus != 4)" @click="showDeactivateDialog(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.deactivate')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="(((userRole == 1 && props.item.tenantId == tenantId) || userRole == 9 || userRole == 15) &&(( props.item.requestStatus == '1' ||  props.item.requestStatus == '2')|| (props.item.requestStatus == '10' && userRole == 9 )))
                                                                 || ((userRole == 2 || userRole == 5) && props.item.requestStatus == '1' && !props.item.providerRejected && isWithinTwoHours(props.item.createdDateTime)
    )
                                                                 " @click="showRejectDialog(props.item)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.reject')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if=" (userRole == 1  || userRole == 9) && ((userRole == 1 && props.item.tenantId == tenantId) || userRole != 1)  && (props.item.requestStatus == '4' || props.item.requestStatus == '2') && props.item.isCritical !== true" @click="showDeleteDialog(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('shared.delete')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="(userRole == 2 || userRole == 5) && !providerLocked && !providerDissconected && props.item.requestStatus == '3'" @click="showresendDialog(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.resend')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile @click="Details(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.details')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="((userRole == 2 || userRole == 5 ) && (props.item.requestStatus == '2' ||props.item.requestStatus == '4') && (props.item.senderStatus == '2' || (props.item.senderStatus == '7'))) && requestsOptions.isChangeSenderTypeEnabled" @click="ChangeSenderType(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('shared.changeSenderType')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="(userRole == 2 || userRole == 5) && !props.item.isClientFavorite " @click="showFavoriteDialog(props.item.crNumber,props.item.enterpriseUnifiedNumber,props.item.customerType)">
                                                        <v-list-tile-title class="white">{{$t('shared.favorite')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="(userRole == 2 || userRole == 5) && props.item.isClientFavorite " @click="showUnfavoriteDialog(props.item.crNumber,props.item.enterpriseUnifiedNumber,props.item.customerType)">
                                                        <v-list-tile-title class="white">{{$t('shared.unfavorite')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="resendDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.resendInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideresendDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="resendComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.resendInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideresendDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="resend('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="favoriteDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.favorite')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideFavoriteDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="mt-3">
                        {{$t('shared.favoriteInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideFavoriteDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="favorClient()">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="unfavoriteDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.unfavorite')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideUnfavoriteDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="mt-3">
                        {{$t('shared.unfavoriteInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideUnfavoriteDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="unfavorClient()">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="finalApproveDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.finalApproveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideFinalApproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>

                    <p class="mt-3">
                        {{$t('shared.finalApproveInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideFinalApproveDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="finalApprove('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideapproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="mt-3">
                        {{$t('shared.approveInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideapproveDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="approve('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="deactivateDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.deactivateInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDeactivateDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{ deactivateConfirmMessage }}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDeactivateDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deactivate">{{$t('shared.yes')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="deleteDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.deleteInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDeleteDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text">
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="deleteComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.deletesenderInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDeleteDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deleteSender">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="rejectdialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.reject')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideRejectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <v-autocomplete :label="$t('dashboardPage.rejectreason')"
                                            :items="popUpRejectionReasons"
                                            return-object
                                            item-value="id"
                                            @input="handleItemChange"
                                            v-model="selectedRejectReason"
                                            item-text="rejectionText"
                                            :disabled="[2,5].includes(userRole)">


                            </v-autocomplete>

                            <div class="form-group" v-if="isItOtherReason">
                                <v-textarea clearable
                                            clear-icon="mdi-close-circle"
                                            bg-color="#dee2e6  !important"
                                            no-resize
                                            maxlength="80"
                                            rows="3"
                                            :label="$t('dashboardPage.rejectreason')"
                                            required
                                            @display=""
                                            :rules="rules"
                                            variant="filled"
                                            v-model="rejectResone">
                                </v-textarea>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideRejectDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" :disabled="!rejectReasonIsValid" @click="reject">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="checkAvailabilityDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.checkAvailability')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideCheckAvailabilityDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.senderName')}}</label>
                                <input class="form-control" v-model="checkAvailabilitySenderName" type="text" />
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideCheckAvailabilityDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" :disabled="!checkAvailabilitySenderName" @click="submitCheckAvailability">{{$t('dashboardPage.checkSender')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="checkSenderDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideCheckSenderdialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row text-center">
                        <div class="col-12">
                            <i class="fas fa-check-circle fa-lg" style="color: #1bb148;font-size:100px;padding-bottom: 10px;"></i>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.senderName')}}</label>
                                <h4 class="user_info_txt">{{senderStatusModel.senderName}}</h4>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{$t('shared.senderType')}}</label>
                                <h4 class="user_info_txt">
                                    <span v-for="(type, index) in senderType" :key="type">
                                        {{getSenderTypeText(type)}}
                                    </span>
                                </h4>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.clientName')}}</label>
                                <h4 class="user_info_txt">{{senderStatusModel.clientName}}</h4>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{$t('shared.senderStatus')}}</label>
                                <h4 class="user_info_txt">{{senderStatusModel.senderStatus}}</h4>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group" v-if="senderStatusModel.customerType !== 0 && senderStatusModel.customerType !== 3">
                                <label v-if="senderStatusModel.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                                <label v-if="senderStatusModel.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                                <label v-if="senderStatusModel.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                                <h4 class="user_info_txt">{{senderStatusModel.crNumber}}</h4>
                            </div>
                            <div class="form-group" v-if="senderStatusModel.customerType === 2 || senderStatusModel.customerType === 3 ">
                                <label>{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                <h4 class="user_info_txt">{{senderStatusModel.enterpriseUnifiedNumber}}</h4>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</div>

